import React from 'react';

/**
 * StepProfessional — Step 0
 * Seleção de profissional com cards premium (foto, nome, profissão, bio, check).
 */
export default function StepProfessional({ professionals, selected, onSelect, onNext }) {
    return (
        <div className="ps-step-content">
            <h2 className="ps-step-title">Escolha o profissional</h2>
            <p className="ps-step-subtitle">Selecione o profissional que deseja realizar seu atendimento.</p>

            <div className="ps-prof-list">
                {professionals.map(prof => {
                    const isSelected = selected?.id === prof.id;
                    return (
                        <div
                            key={prof.id}
                            className={`ps-prof-card${isSelected ? ' ps-prof-card--selected' : ''}`}
                            onClick={() => onSelect(prof)}
                        >
                            {/* Avatar */}
                            <div className="ps-prof-card__avatar-wrap">
                                {prof.photo
                                    ? <img src={prof.photo} alt={prof.name} className="ps-prof-card__avatar" />
                                    : (
                                        <div className="ps-prof-card__avatar ps-prof-card__avatar--placeholder">
                                            {prof.name.charAt(0).toUpperCase()}
                                        </div>
                                    )
                                }
                            </div>

                            {/* Info */}
                            <div className="ps-prof-card__info">
                                <span className="ps-prof-card__name">{prof.name}</span>
                                {prof.profession && (
                                    <span className="ps-prof-card__profession">{prof.profession}</span>
                                )}
                                {prof.bio && (
                                    <span className="ps-prof-card__bio">{prof.bio}</span>
                                )}
                            </div>

                            {/* Check icon */}
                            {isSelected && (
                                <div className="ps-prof-card__check">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="12" fill="#ED3680" />
                                        <path d="M7 12l4 4 6-6" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="ps-actions ps-actions--single">
                <button
                    className="ps-btn ps-btn--primary ps-btn--full"
                    disabled={!selected}
                    onClick={onNext}
                >
                    Continuar
                </button>
            </div>

            <p className="ps-trust-note">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Seus dados estão protegidos
            </p>
        </div>
    );
}
